import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';
import TrackingComponent from '../components/TrackingComponent';

export default class FooterNewsletterComponent extends Component {
  get SELECTORS() {
    return {
      hiddenBlock: '[data-newsletter-f-hidden]',
      submitButton: '[data-submit-button]',
      checkSubmitBtns: '[data-check-submit]',
      signupMarinaCheckbox: '[data-signup-marina-checkbox]',
      signupPersonaCheckbox: '[data-signup-persona-checkbox]',
      formWrapper: '[data-js-form-wrapper]',
      formSuccess: '[data-js-form-success]',
      newsletterError: '[data-newsletter-error-msg]',
      newsletterAlready: '[data-newsletter-already-msg]',
      form: '[data-form-newsletter]',
      emailInput: '[data-email-input-newsletter]',
      privacyCheckbox: '[data-privacy-checkbox]',
      submitBtn: '[data-nl-form-submit]',
      newsletterContent: '[data-newsletter-content]',
      newsletterSuccess: '[data-nl-success]',
    };
  }

  get CLASSES() {
    return {
      success: 'success',
      show: 'show',
      hidden: 'hidden',
      error: 'error'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.html = htmlEl;
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.hiddenBlock = this.$component.querySelector(this.SELECTORS.hiddenBlock);
    this.checkSubmitBtns = this.$component.querySelectorAll(this.SELECTORS.checkSubmitBtns);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.signupMarinaCheckbox = this.$component.querySelector(this.SELECTORS.signupMarinaCheckbox);
    this.signupPersonaCheckbox = this.$component.querySelector(this.SELECTORS.signupPersonaCheckbox);
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.emailInput = this.$component.querySelector(this.SELECTORS.emailInput);
    this.formWrapper = this.$component.querySelector(this.SELECTORS.formWrapper);
    this.formSuccess = this.$component.querySelector(this.SELECTORS.formSuccess);
    this.newsletterError = this.$component.querySelector(this.SELECTORS.newsletterError);
    this.newsletterAlready = this.$component.querySelector(this.SELECTORS.newsletterAlready);
    this.submitBtn = this.$component.querySelector(this.SELECTORS.submitBtn);
    this.trackingComponent = new TrackingComponent();
  }

  listenInput() {
    const ctx = this;
    ctx.emailInput.addEventListener('focus', () => {
      ctx.hiddenBlock.classList.add(this.CLASSES.show);
      ctx.checkSubmit();
    });
  }

  enableSubmitBtn() {
    if ( this.privacyCheckbox.checked && ( this.signupMarinaCheckbox.checked || this.signupPersonaCheckbox.checked) ) {
      this.submitButton.disabled = false;
    } else {
      this.submitButton.disabled = true;
    }
  }

  checkSubmit() {
    const ctx = this;
    if (this.checkSubmitBtns != null) {
      this.checkSubmitBtns.forEach((checkbox, index) => {
        checkbox.addEventListener('click', e => {
          ctx.enableSubmitBtn();
        });
      });
    }
  }

  handleFormSubmit() {
    if(this.form) {
      const url = this.form.getAttribute('action');
      const ctx = this;
      this.form.addEventListener("submit", (event) => {
        const form = new FormData(event.target);
        event.preventDefault();
        const response = this.NewsletterLogic.subscribeNewsletter(url, form);
        response.then(response => {
          if(response.ok) {
            let data = ctx.checkTrakingDataset(ctx.submitButton.dataset);
            ctx.trackingComponent.trackAction('newsletterSubscribe', data);
            ctx.formWrapper.classList.add(this.CLASSES.hidden);
            ctx.formSuccess.classList.remove(this.CLASSES.hidden);
            ctx.newsletterError.classList.add(this.CLASSES.hidden);
            ctx.newsletterAlready.classList.add(this.CLASSES.hidden);
          } else {
            if (response.status === 400) {
              ctx.newsletterError.classList.remove(ctx.CLASSES.hidden);
              ctx.emailInput.classList.add(ctx.CLASSES.error);
            }
            if (response.status === 403) {
              ctx.newsletterAlready.classList.remove(ctx.CLASSES.hidden);
              ctx.emailInput.classList.add(ctx.CLASSES.error);
            }
            ctx.formWrapper.classList.remove(ctx.CLASSES.hidden);
            ctx.formSuccess.classList.add(ctx.CLASSES.hidden);
          }
        })
      });
    }
  }

  checkTrakingDataset(dataBtn){
    const ctx = this;
    let email = ctx.html.querySelector('input[type="email"]')
    if(email){
      dataBtn.customerEmail = email.value
    }
    return dataBtn
  }

  handleInputChange() {
    const ctx = this;
    if(this.emailInput) {
      this.emailInput.addEventListener("input", event => {
        ctx.newsletterError?.classList.add(this.CLASSES.hidden);
        ctx.newsletterAlready?.classList.add(this.CLASSES.hidden);
      });
    }
  }

  bindEvents() {
    this.enableSubmitBtn();
    this.handleFormSubmit();
    this.handleInputChange();
  }

  render() {
    super.render();
    this.listenInput();
    this.NewsletterLogic = new NewsletterLogic();
    this.bindEvents();
  }
}
